<script>
  import EventBus from 'components/helpers/event-bus'
  import isEmpty from 'lodash/isEmpty'
  import forEach from 'lodash/forEach'
  import drop from 'lodash/drop'
  import head from 'lodash/head'
  import get from 'lodash/get'
  import { isDomElement } from 'mixins/utilities'

  export default{
    props: {
      articleTitle: {
        type: String,
      },
      theme: {
        type: String,
        default: 'desktop',
      },
    },
    data: () => ({
      items: [],
      galleryItems: [],
    }),
    mounted() {
      this.initFullScreen()
      this.openFromBeginning()
    },
    methods: {
      openFromBeginning() {
        const getPhotoFromUrl = get(this, '$route.fullPath').match(/(gallery)\/(\d{1,2})\/?/)
        if (getPhotoFromUrl && isDomElement(get(this, '$refs.galleryContainer'))) {
          const photos = this.$refs.galleryContainer.querySelectorAll('.photos')
          if (get(photos, `[${(parseInt(getPhotoFromUrl[2], 0) - 1)}]`)) photos[(parseInt(getPhotoFromUrl[2], 0) - 1)].click()
        }
      },
      initFullScreen() {
        const galleryElements = this.$refs.galleryContainer
        // bind event to open overlay
        if (!isEmpty(galleryElements)) {
          galleryElements.onclick = this.onThumbnailsClick
        }
      },
      onThumbnailsClick(e) {
        e = e || window.event
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
        const eTarget = e.target || e.srcElement
        const clickedListItem = this.closest(eTarget, (el) => {
          const className = el.className instanceof window.SVGAnimatedString ? el.className.baseVal : el.className
          return className && className.match(/THUMBNAIL/gi)
        })

        if (!clickedListItem) {
          return
        }
        // fetch html element into items object
        const clickedGallery = clickedListItem.parentNode.parentNode
        let childNodes = []
        forEach(clickedGallery.childNodes, (nodes) => {
          childNodes = [...childNodes, ...nodes.childNodes]
        })
        const numChildNodes = childNodes.length
        let nodeIndex = 0
        let index = 0


        for (let i = 0; i < numChildNodes; i += 1) {
          if (childNodes[i] === clickedListItem) {
            index = nodeIndex
            break
          }
          nodeIndex += 1
        }

        if (index >= 0) {
          EventBus.$emit('openPhotoSlider', index, clickedGallery.childNodes, {}, this.articleTitle)
        }
      },
      closest(el, fn) {
        return el && (fn(el) ? el : this.closest(el.parentNode, fn))
      },
    },
    render(createElement) {
      const renderElements = []

      if (this.$slots.thumbnail) {
        const thumbnails = this.$slots.thumbnail
        const wrapperTwoElement = drop(thumbnails)

        while (wrapperTwoElement.length > 0 && wrapperTwoElement.length < 3) {
          wrapperTwoElement.push(createElement('div', {class: {thumbnail: true}, style: {'background-image': "url('/image/placeholder/1/1/5A9CB5/20')"}}))
        }

        const galleryContainerClass = {
          'gallery-container': true,
          clear: true,
        }
        galleryContainerClass[`length-${thumbnails.length}`] = true
        galleryContainerClass[`${this.theme}`] = true

        renderElements.push(createElement('div', {
          class: galleryContainerClass,
          ref: 'galleryContainer',
        }, [createElement('div', {
          class: {
            gallery: true,
            clear: true,
          },
          attrs: {
            articleTitle: this.articleTitle,
          },
        }),
        createElement('div', {class: {'wrapper-one': true}}, [head(thumbnails)]),
        createElement('div', {class: {'wrapper-two': true}}, wrapperTwoElement),
        createElement('div', {class: {clear: true}}, '')]))
      }

      return createElement('div', {
        class: {
          'gallery-wrapper': true,
          'no-article-gutter-mobile': true,
        },
      }, renderElements)
    },
  }
</script>


<style lang="scss">
  $gallery-padding-between-images-desktop: rem-calc(7);

  .clear{ clear: both; }
  .gallery-wrapper {
    width: 100%;

    .gallery-container {
      margin: rem-calc(0 0 40 0);
    }

    .gallery-container:not(.mobile) {

      @include respond-to('desktop'){
        height: rem-calc(523);
      }

      .gallery-icon svg{
        @include respond-to('desktop'){
          bottom: rem-calc(23);
          left: rem-calc(20);
          width: rem-calc(60);
          height: rem-calc(60);
          padding: rem-calc(15);
        }
      }

      .wrapper-one {
        @include respond-to('desktop'){
          float: left;
          height: 100%;
          width: 75%;
          border-right: $gallery-padding-between-images-desktop solid transparent;
          .thumbnail {
            height: 100%;
            width: 100%;
          }
        }
      }
      .wrapper-two{
        @include respond-to('desktop'){

          float: left;
          height: 100%;
          width: 25%;
          display: flex;
          flex-direction: column;

          .thumbnail {
            width: 100%;
            height: calc(100% / 3);
            border-bottom: $gallery-padding-between-images-desktop solid transparent;
            &:nth-child(3) {
              border-bottom: none;
            }
          }
        }
      }
      &.length-1 {
        @include respond-to('desktop'){
          .wrapper-one{
            width: 100%;
            .thumbnail{
              img{
                height: auto;
                width: 100%;
              }
            }
          }
          .wrapper-two{
            width: 0%;
          }
        }
      }
    }

    .gallery-container.mobile {
      .gallery-icon svg{
        bottom: 4.19%;
        left: 3.98%;
        width: 7%;
        height: 7%;
        padding: 1.75%;
      }
      .wrapper-one {
        margin-bottom: rem-calc(3);
        box-sizing: content-box;
        .thumbnail{
          width: 100%;
          height: auto;
          .photos{
            width: 100%;
            height: auto;
            img{
              width: 100%;
            }
          }
          .gallery-icon{
            box-sizing: border-box;
          }
        }
      }
      .wrapper-two {
        box-sizing: content-box;
        .thumbnail {
          width: calc(100% / 3 - 2px);
          height: calc(100% / 3 - 2px);
          .photos {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
            }
          }
          &:first-child {
            border-right: 3px solid transparent;
          }
          &:nth-child(2) {
            border-right: 3px solid transparent;
          }
        }
      }
    }

    .gallery-container {
      width: 100%;
      position: relative;
      .gallery{
        cursor: pointer;
      }
      .gallery-icon svg{
        fill: $white;
        background: $fluorescent-pink;
        position: absolute;
        @include  respond-to('mobile'){
          bottom: 4.19%;
          left: 3.98%;
          width: 7%;
          height: 7%;
          padding: 1.75%;
        }
      }

      .wrapper-one{
        @include respond-to('mobile'){
          margin-bottom: rem-calc(3);
          box-sizing: content-box;
          .thumbnail{
            width: 100vw;
            height: 100vw;
            .photos{
              width: 100vw;
              height: 100vw;
              img{
                width: 100%;
              }
            }
            .gallery-icon{
              box-sizing: border-box;
            }
          }
        }
      }

      .wrapper-two{
        @include respond-to('mobile'){
          box-sizing: content-box;
          width: 100vw;
          .thumbnail {
            width: calc(100vw / 3 - 2px);
            height: calc(100vw / 3 - 2px);
            float: left;
            .photos {
              width: calc(100vw / 3 - 2px);
              height: calc(100vw / 3 - 2px);
              img {
                width: 100%;
              }
            }
            &:first-child {
              border-right: 3px solid $white;
            }
            &:nth-child(2) {
              border-right: 3px solid $white;
            }
          }
        }

        .thumbnail {
          .gallery-icon.number-two svg{
            display: none;
          }

          &:nth-child(3) {
            .overlay {
              opacity: 1;
              span{
                @include respond-to('desktop'){
                  font-size: rem-calc(59);
                }
              }
            }
          }
          &:nth-child(n+4) {
            display: none;
          }
        }
      }

      &.length-1{
        .wrapper-one{
          border-right: none;
        }
      }

      .thumbnail {
        display: inline-block;
        position: relative;
        margin: auto;
        overflow: hidden;
        &.first {
          display: block;
        }
        &:hover .photos, &:focus .photos {
          -webkit-filter: $image-hover-opacity;
        }
        .photos{
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          div {
            height: 100%;
            width: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
        &:last-child {
          &:after {
            clear: both;
          }
        }

        .overlay {
          opacity: 0;
          color: $white;
          width: 100%;
          height: 100%;
          background: $black-50;
          position: absolute;
          top: 0;
          left: 0;
          span {
            font-size: 8.5vw;
            position: relative;
            float: left;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Gallery.vue?2e199721